import { Component, inject, OnInit, Signal, signal, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from "@angular/material/icon";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DType } from '@grupo-constant/next-dtype/types';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';
import { SendQRToMissionUserRequest, ServiceWorkplaceUserAssignment } from '../../modules/admin/services/services.types';
import { ServicesService } from '../../modules/admin/services/services.service';

@Component({
    selector: 'app-user-qr-dialog',
    templateUrl: './user-qr-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, MatIcon, MatTooltipModule, MatButtonModule]
})
export class UserQrDialogComponent implements OnInit{

    public data: {
        dtype: Signal<DType>,
        assignment: ServiceWorkplaceUserAssignment
    } = inject(MAT_DIALOG_DATA);

    qr = signal(null);

    private servicesService = inject(ServicesService);
    private dialogRef = inject(MatDialogRef<UserQrDialogComponent>);
    private snackbar = inject(MatSnackBar);
    private transloco = inject(TranslocoService);

    async ngOnInit(): Promise<void> {
        const reply = await firstValueFrom(this.servicesService.retrieveMissionUserQR({
            idNumber: this.data.assignment.sAMAccountName 
        }));
        this.qr.set(reply.qr);
    }

    async sendQRToMissionUser() {
        const assignment = this.data.assignment;
        const query: SendQRToMissionUserRequest = {
            serviceId: assignment.serviceId,
            workplaceCode: assignment.workplaceCode,
            userId: assignment.userId
        }
        
        this.closeDialog();
        const reply = await firstValueFrom(this.servicesService.sendQRToMissionUser(query));
        if (reply.status < 400) {
            this.snackbar.open(this.transloco.translate('QRSentToMissionUser') + ": " + assignment.userName, this.transloco.translate('accept'), { duration: 5000 });
        }
    }

    async closeDialog() {
        this.dialogRef.close();
    }
}
